import { Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useState, useEffect } from "react";
import useTabStyles from "../../styles/useTabStyles";
import { getFeaturePermissions } from "../../util/permissions";
import { useAppSelector } from "../../redux/hooks";

export type TabSectionProps = {
  tabList: any;
  setParentTabState?: Function;
  selectedTab?: string;
};

const MemberTab: React.FunctionComponent<TabSectionProps> = (
  props: TabSectionProps
) => {
  const { tabList, setParentTabState, selectedTab } = props;
  const tabStyes = useTabStyles();
  const [activeTab, setActiveTab] = useState<any>(
    selectedTab ?? tabList[0].title
  );
  const theme = useTheme();
  const handleTabSelection = (e: React.SyntheticEvent) => {
    const { innerText } = e.target as HTMLElement;
    setActiveTab(innerText);
  };
  const permissions = useAppSelector(
    (state: any) => state.persistReducers.login.permissions
  );

  useEffect(() => {
    setActiveTab(activeTab);
    if (setParentTabState instanceof Function) setParentTabState(activeTab);
  }, [activeTab]);

  return (
    <>
      {tabList.map((tab: any, i: number) => {
        return (
          <Grid item height={"100%"} justifyContent={"center"} key={i} mx={2}>
            <Typography
              px={1}
              height={"93%"}
              color={theme?.color?.primary}
              display={"flex"}
              alignItems={"center"}
              fontFamily={theme.font?.fontFamily.primary}
              fontSize={theme.font?.fontSize.cardHeader}
              sx={
                activeTab === tab.title
                  ? { ...tabStyes.active, ...tabStyes.hover }
                  : { ...tabStyes.hover }
              }
              onClick={handleTabSelection}
            >
              {tab.title}
            </Typography>
          </Grid>
        );
      })}
    </>
  );
};

export default MemberTab;
